import { Component, Input } from '@angular/core';

import { PurchaseResponseDto, PurchaseStatusEnumText } from '@api';

import { DefaultModule, PrimeModule } from '@module';
import { TranslationsPipe } from '@shared';

import { DatePipe } from 'pn-core-code';

import { Tag } from 'primeng/tag';

@Component({
  selector: 'e-general-information',
  standalone: true,
  imports: [DefaultModule, PrimeModule, TranslationsPipe, DatePipe, Tag,],
  templateUrl: './e-general-information.component.html',
  styleUrl: './e-general-information.component.scss'
})
export class EGeneralInformationComponent {
  @Input() purchaseData: PurchaseResponseDto = {} as PurchaseResponseDto;
  statusPurchaseType = PurchaseResponseDto.StatusEnum;
  purchaseStatusEnumText = PurchaseStatusEnumText;
}
